<div class="container-fluid pagecard list-page-main" id="addons-list-page">

  <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
    <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active">

      <ng-container [ngbNavItem]="1">
        <a ngbNavLink routerLink="/merchants">{{'Active' | translate | async }}</a>
      </ng-container>

      <ng-container [ngbNavItem]="2">
        <a ngbNavLink> {{ 'Archived' | translate | async }}</a>
        <ng-template ngbNavContent>
          <div *ngIf="isEmpty" class="empty-courses d-none">
            <div class="text-center">
              <img src="../../../../assets/images/empty-add-on-groups.svg" class="mb-3">
              <h2 class="fw-600 mb-3">{{ "Merchant" }}</h2>
              <p class="f-16 mb-3">{{ "No Merchants Available" }}</p>
              <!-- <button class="create-btn" (click)="goToAddPage()">
                {{ "New Merchant" }}
              </button> -->
            </div>
        </div>

        <div *ngIf="!isEmpty" class="position-relative" style="margin-top: -56.5px">
          <div class="table-responsive d-grid">
              <table id="addons-table" datatable class="display" cellspacing="0" width="100%" [dtOptions]="dtOptions">
                <thead>
                    <tr>
                      <th class="text-left">
                        <input type="checkbox"  style="width: 20px;" [checked]="allMerchantsSelected" (change)="toggleSelectAll($event)">
                      </th>
                        <th class="text-left">Merchant Name</th>
                        <th class="text-center">Email</th>
                        <th class="text-center">Contact No</th>
                        <th class="text-center">Store</th>
                        <th class="text-center">License Expiry</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="fw-500">
                    <tr *ngFor="let merchant of merchants"  style="cursor: pointer;">
                      <td style="width: 20px;">
                        <input
                          type="checkbox"
                          [(ngModel)]="merchant.selected"
                          (change)="selectMerchant($event, merchant)"
                        >
                      </td>
                      <td class="text-left">{{merchant.merchantName}}</td>
                        <!-- <td class="text-center">{{merchant.merchantEmail}}</td> -->
                        <td class="text-center">
                          <ng-container *ngIf="merchant.merchantEmail; else noEmailTemplate">
                            {{ merchant.merchantEmail }}
                          </ng-container>
                          <ng-template #noEmailTemplate>
                            <span>No Email Available</span>
                          </ng-template>
                        </td>
                        <!-- <td class="text-center">{{merchant.merchantMobile}}</td> -->
                        <td class="text-center">
                          <ng-container *ngIf="merchant.merchantMobile; else noMobileTemplate">
                            {{ merchant.merchantMobile }}
                          </ng-container>
                          <ng-template #noMobileTemplate>
                            <span>No Mobile Available</span>
                          </ng-template>
                        </td>
                        <td class="text-center">
                          {{merchant?.stores[0]?.storeName}}
                          <span *ngIf="merchant.stores.length > 1">+ {{merchant.stores.length - 1}} </span>
                        </td>
                        <!-- <td class="text-center">{{ merchant.licenseExpiration * 1000 | date:'MMM d, y, h:mm a' }}</td> -->
                        <td class="text-center">
                          <ng-container *ngIf="merchant.licenseExpiration; else errorTemplate">
                            {{ _convertDate(merchant.licenseExpiration) }}
                          </ng-container>
                          <ng-template #errorTemplate>
                            <span>No Expiry Date available.</span>
                          </ng-template>
                        </td>
                        <td>
                          <div
                            class="gap-1 d-flex justify-content-end align-items-center"
                          >
                            <div ngbDropdown container="body">
                              <div class="cursor-pointer" ngbDropdownToggle>
                                <i class="fas fa-ellipsis-v"></i>
                              </div>
                              <div
                                ngbDropdownMenu
                              >
                                <button
                                  ngbDropdownItem
                                  accessControl module="Merchants" access="3"
                                  (click)="
                                    unarchiveMerchant(merchant.merchantId, unarchiveContent)
                                  "
                                >
                                  {{ "Unarchive" | translate | async }}
                                </button>
                                <button
                                  ngbDropdownItem
                                  accessControl module="Merchants" access="3"
                                  (click)="deleteMenu(merchant.merchantId, content)"
                                >
                                  {{ "Permanently delete" | translate | async }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                    </tr>
                </tbody>
              </table>
          </div>
          <div class="position-absolute signupbtn">
            <button class="new-btn" accessControl module="Merchants" access="3" (click)="deleteMerchantsmodel()" style="margin-right: 10px;">
              Delete Selected
            </button>
            <!-- <button [hidden]="!isSignUpAllowed" class="new-btn" (click)="goToMerchantSignupPage()">
              + Sign Up
            </button> -->
          </div>
        </div>
        </ng-template>
      </ng-container>

      <ng-container [ngbNavItem]="3">
        <a ngbNavLink routerLink="/merchants/merchant-onboard">{{'New Onboard' | translate | async }}</a>
      </ng-container>

      <ng-container [ngbNavItem]="4">
        <a ngbNavLink routerLink="/merchants/merchant-internal">{{'Internal' | translate | async }}</a>
      </ng-container>
      <ng-container [ngbNavItem]="5">
        <a ngbNavLink routerLink="/merchants/quick-actions">{{'Quick Actions' | translate | async }}</a>
      </ng-container>
    </nav>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<ng-template #unarchiveContent role="document" let-modal>
  <div class="modal-body border-0">
    <div class="delete-icon-info">
      <div class="delete-icon-info-img">
        <div
          class="swal2-icon swal2-warning swal2-icon-show"
          style="display: flex; animation: none !important"
        >
          <div class="swal2-icon-content">!</div>
        </div>
        <h2 class="swal2-title" id="swal2-title" style="display: flex">
          {{ "Are you sure?" | translate | async }}
        </h2>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button
            class="btn add-btn-one fw-bold mt-2"
            (click)="unarchiveMenuFunction(content)"
          >
            {{ "Yes, unarchive it!" | translate | async }}
          </button>
          <button
            class="btn btn-dark add-btn fw-bold mt-2"
            style="margin-left: 15px"
            (click)="cancelDeleteAll(content)"
          >
            {{ "Cancel" | translate | async }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #content role="document" let-modal>
  <div class="modal-body border-0">
    <div class="delete-icon-info">
      <div class="delete-icon-info-img">
        <div
          class="swal2-icon swal2-warning swal2-icon-show"
          style="display: flex; animation: none !important"
        >
          <div class="swal2-icon-content">!</div>
        </div>
        <h2 class="swal2-title" id="swal2-title" style="display: flex">
          {{ "Are you sure?" | translate | async }}
        </h2>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button
            class="btn add-btn-one fw-bold mt-2"
            style="margin-bottom: 15px"
            (click)="deleteMerchantFunction(content)"
          >
            {{ "Yes, permanently delete it!" | translate | async }}
          </button>
          <button
            class="btn btn-dark add-btn-two fw-bold mt-2"
            style="margin-left: 15px; margin-bottom: 15px"
            (click)="cancelDeleteAll(content)"
          >
            {{ "Cancel" | translate | async }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #Delete role="document" let-modal>
  <div class="modal-body border-0">
      <div class="delete-icon-info text-center">
          <div class="swal2-icon swal2-warning swal2-icon-show" style="border: 0.25em solid; border-color: #facea8; color: #f8bb86; position: relative; box-sizing: content-box; justify-content: center; width: 5em; height: 5em; margin: 2.5em auto 0.6em; border-radius: 50%;">
              <div class="swal2-icon-content" style="align-items: center; font-size: 3.75em;">
                  !
                </div>
            </div>
          <h2 class="swal2-title" id="swal2-title">
              {{ "Are you sure?" | translate | async }}
          </h2>
      </div>
  </div>
  <div class="modal-footer border-0">
      <div class="container">
          <div class="row align-items-center">
              <div class="col-12 text-center">
                  <button class="btn add-btn-one fw-bold mb-2 mt-2 mr-2" style="margin-right: 10px;" (click)="deleteSelectedMerchants()">
                      {{ "Yes, delete it!" | translate | async }}
                    </button>

                    <button class="btn btn-dark fw-bold add-btn-two mb-2 mt-2" (click)="cancelDeleteAll(content)">
                      {{ "Cancel" | translate | async }}
                    </button>
              </div>
          </div>
      </div>
  </div>
</ng-template>
